// extracted by mini-css-extract-plugin
module.exports = {"rankImage":"RankingPalette_rankImage___L8Ys"};